// extracted by mini-css-extract-plugin
export default {"heading":"bw-z","corrected":"cw-z","redirectVerbiageContainer":"dw-z","redirectVerbiageText":"ew-z"};